import { render, staticRenderFns } from "./ULoader.vue?vue&type=template&id=748baa5c"
import script from "./ULoader.vue?vue&type=script&lang=js"
export * from "./ULoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports